import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from "../../../SpecialtyPersonalStyles.module.scss"
import metadata from './IncidentalOfficeComponent.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function IncidentalOffice(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('IncidentalOffice');

    const modelVM = _.get(submissionVM, pathUpdated);

    if( modelVM &&  modelVM.value) {
        modelVM.value.isValidationReq = true;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifyespleexpFie: {
            visible: _.get(modelVM, 'docliorsupevecomtopreFie.value') === true 
        },
        ifyespleproCarFie: {
            visible: _.get(modelVM, 'doyoucarliainsfortactFie.value') === true 
        },
        pleproPolFie: {
            visible: _.get(modelVM, 'doyoucarliainsfortactFie.value') === true 
        },
        pleproExpDatFie1: {
            visible: _.get(modelVM, 'doyoucarliainsfortactFie.value') === true 
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

IncidentalOffice.propTypes = wizardProps;
export default withRouter(IncidentalOffice);